/**
 * Validate Password Function
 * @param {Number} passwordLength
 * @param {Object} state
 * @return {String}
 */
const validateCreatePassword = (passwordLength, state) => {
  let validationError = '';
  if (passwordLength === 0) {
    validationError = 'inputRequired';
  } else if (passwordLength < 8) {
    validationError = 'shortPassword';
  } else if (!state.passwordConfirm) {
    validationError = 'confirmPassword';
  } else if (state.passwordConfirm && state.password !== state.passwordConfirm) {
    validationError = 'notMatchingPasswords';
  }
  return validationError;
};

export default validateCreatePassword;